import { useEffect, useRef } from "react";

// Shown when the patient tries to leave a part-completed form from the header. Answers are saved a
// page at a time (the renderer posts them on Continue), so only the page they are on is at risk -
// hence "answers on this page" rather than implying the whole form is lost.
export const LeaveFormWarning = ({
  onStay,
  onLeave,
}: {
  onStay: () => void;
  onLeave: () => void;
}) => {
  const stayButton = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    stayButton.current?.focus();

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onStay();
    };

    document.addEventListener("keydown", onKeyDown);

    const { overflow } = document.body.style;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = overflow;
    };
  }, [onStay]);

  return (
    <div
      className="rs-leave-warning"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="rs-leave-warning-title"
      aria-describedby="rs-leave-warning-body"
    >
      <div className="rs-leave-warning__panel">
        <h2 id="rs-leave-warning-title" className="rs-leave-warning__title">
          Are you sure you want to leave?
        </h2>
        <p id="rs-leave-warning-body">
          Your answers on this page will not be saved.
        </p>
        <div className="rs-leave-warning__actions">
          <button
            ref={stayButton}
            type="button"
            className="nhsuk-button"
            data-module="nhsuk-button"
            style={{ marginBottom: 0 }}
            onClick={onStay}
          >
            Stay
          </button>
          <button
            type="button"
            className="nhsuk-button nhsuk-button--secondary"
            data-module="nhsuk-button"
            style={{ marginBottom: 0 }}
            onClick={onLeave}
          >
            Leave
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeaveFormWarning;
